import { Box, TextButton } from '@wix/design-system';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { useRedesignedDisclaimers } from '../../../hooks/useRedesignedDisclaimers';
import { AI_CREDITS_DISCLAIMER_KEY, AI_CREDITS_URL, REDESIGNED_TAX_EXCLUSIVE_KEY, REDESIGNED_TAX_INCLUSIVE_KEY } from '../../../utils';
import { useDisclaimerTranslationTags } from '../useDisclaimerTranslationTags';
export const SelectPlanDisclaimer = function (_temp) {
  var _taxStatus$data;
  let {
    isMobile,
    hideAiCredits,
    plainText
  } = _temp === void 0 ? {} : _temp;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isRedesignEnabled = useRedesignedDisclaimers();
  const taxStatus = module.SDK.eclipseOfferingApiClient.hooks.useFetchTaxStatus({});
  const isPricesIncludeTax = ((_taxStatus$data = taxStatus.data) == null ? void 0 : _taxStatus$data.treatment) === 'INCLUSIVE';
  const translationTags = useDisclaimerTranslationTags({
    isMobile,
    plainText
  });
  if (isRedesignEnabled) {
    const priceDisclaimer = /*#__PURE__*/React.createElement(Trans, {
      i18nKey: isPricesIncludeTax ? REDESIGNED_TAX_INCLUSIVE_KEY : REDESIGNED_TAX_EXCLUSIVE_KEY,
      components: translationTags
    });
    if (!isMobile || hideAiCredits) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, priceDisclaimer);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, priceDisclaimer, /*#__PURE__*/React.createElement(Box, {
      display: "block",
      marginTop: "SP3"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: AI_CREDITS_DISCLAIMER_KEY,
      components: {
        1: /*#__PURE__*/React.createElement(TextButton, {
          size: "tiny",
          weight: "normal",
          skin: "dark",
          underline: "always",
          as: "a",
          href: AI_CREDITS_URL,
          target: "_blank"
        })
      }
    })));
  }
  const isAiFeaturesEnabled = experiments.isEnabled('specs.premium.AICreditsWallet');
  const regularDisclaimer = isPricesIncludeTax ? /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "page_footer.plans_disclaimer_no_vat",
    components: translationTags
  }) : /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "page_footer.plans_disclaimer_applicable_tax",
    components: translationTags
  });
  if (!isAiFeaturesEnabled || hideAiCredits) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, regularDisclaimer);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, regularDisclaimer, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "premium-purchase-plan.package_picker.disclaimer.ai_features"
  }), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "premium-purchase-plan.package_picker.disclaimer.ai_usage",
    components: {
      1: isMobile ? /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        weight: "normal",
        skin: "dark",
        underline: "always",
        as: "a",
        href: AI_CREDITS_URL,
        target: "_blank"
      }) : /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        weight: "thin",
        as: "a",
        href: AI_CREDITS_URL,
        target: "_blank"
      })
    }
  }));
};
//# sourceMappingURL=SelectPlanDisclaimer.js.map